export default "__VITE_ASSET__z8oW33Vf__"